import { render } from "./new-exception.vue?vue&type=template&id=1f4fa49a"
import script from "./new-exception.vue?vue&type=script&lang=js"
export * from "./new-exception.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__